import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { notificationObject, packageObject } from './release-modal.models';


@Injectable({
  providedIn: 'root'
})
export class ReleaseModalService {



  constructor(private CVApiService: CVApiService) { }

  public async partnerSalesPackage(){
    try{
      let response = await (this.CVApiService.get<packageObject[]>(`/api/v1/getPartnerSalesPackage`));
      if (response.status_code === 200)
        return response.data;
      else throw response;
    } catch (err) {
        console.error("Failed to load package data");
      throw err;
    }
  }

  public async partnerID(){
    try{
      let response = await this.CVApiService.get(`/api/v1/getPartnerID`);
      if (response.status_code === 200)
        return response.data;
      else throw response;
    } catch (err) {
        console.error("Failed to load partner data");
      throw err;
    }
  }

  public async notificationID(){
    try{
      let response = await (this.CVApiService.get<notificationObject[]>(`/api/v1/notifications`));
      if (response.status_code === 200)
        return response.data;
      else throw response;
    } catch (err) {
        console.error("Failed to load notification data");
      throw err;
    }
  }
}
